import { render, staticRenderFns } from "./InterpreterForAdminFAIBlock.vue?vue&type=template&id=6c55e6a4&scoped=true&"
import script from "./InterpreterForAdminFAIBlock.vue?vue&type=script&lang=js&"
export * from "./InterpreterForAdminFAIBlock.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterForAdminFAIBlock.vue?vue&type=style&index=0&id=6c55e6a4&prod&lang=css&"
import style1 from "@assets/css/interpreter_for_admin_fai_block.css?vue&type=style&index=1&id=6c55e6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55e6a4",
  null
  
)

export default component.exports